export enum AlarmNotificationTypeEnum {
    Once = 1,
    EveryXMinutes = 2,
    ZTimesYMinutesApart = 3
}
